// THIS FILE IS GENERATED, DO NOT EDIT!
/* eslint-disable */
import * as Types from '@h5s/dtos-api';

import { LocalDate, LocalDateTime, LocalTime } from '@h5s/util-date';
import { gql } from 'apollo-angular';
import { InvoiceBlockRulesFragment } from '../../fragments/generated/invoice-block-rules.fragment.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type GetActiveInvoiceBlocksQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetActiveInvoiceBlocksQueryResult = { __typename?: 'Query', getActiveInvoiceBlocks: { __typename?: 'InvoiceBlockRulesDTO', blockOptional: boolean, blocks: Array<string> } };

export const GetActiveInvoiceBlocksGql = gql`
    query GetActiveInvoiceBlocks {
  getActiveInvoiceBlocks {
    ...InvoiceBlockRules
  }
}
    ${InvoiceBlockRulesFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetActiveInvoiceBlocksInjectable extends Apollo.Query<GetActiveInvoiceBlocksQueryResult, GetActiveInvoiceBlocksQueryVariables> {
    override document = GetActiveInvoiceBlocksGql;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
/* eslint-enable */